import React from 'react';

import { Message, Button, LinkText } from 'common/components';
import { Glossary, HistoryGL } from 'common/utils/glossary';

export enum PlanStatus {
  // 購入
  CONTRACT = 1,
  // 解約
  CANCEL = 2,
  // 有効期限切れ
  EXPIRED = 3,
  // 契約保留中
  HOLD = 4,
  // 一部解約
  INDIVIDUAL_CANCEL = 5,
  // 自動更新OFF
  MANUAL_UPDATE = 6
}

interface PurchaseHistoryProps {
  /** プラン名 */
  planName: string;
  /** プランの購入or解約日時 */
  operationDatetime: string;
  /** プランの状態 */
  status: PlanStatus;
  /** 再購入ボタン表示有無 */
  isShow: boolean;
  /** 再購入をクリック時のコールバック関数 */
  onClickPurchase: () => void;
  /** プラン名をクリック時のコールバック関数 */
  onClickDetail: () => void;
  /** E2Eテスト用識別子 */
  'data-test': string;
  /** グロッサリ */
  glossary: Glossary;
}

const PurchaseHistoryInfo: React.FC<PurchaseHistoryProps> = ({
  planName,
  operationDatetime,
  status,
  isShow,
  onClickPurchase,
  onClickDetail,
  'data-test': dataTest,
  glossary
}) => {
  let _status_message = '';
  let _is_red = false;
  const _is_show = isShow;
  if (status == PlanStatus.CONTRACT) {
    // 「購入」メッセージ
    _status_message = glossary.glx(HistoryGL.Contract);
  } else if (status == PlanStatus.CANCEL) {
    // 「解約」メッセージ
    _status_message = glossary.glx(HistoryGL.Cancel);
    _is_red = true;
  } else if (status == PlanStatus.INDIVIDUAL_CANCEL) {
    // 「一部解約」メッセージ
    _status_message = glossary.glx(HistoryGL.IndividualCancel);
    _is_red = true;
  } else if (status == PlanStatus.EXPIRED) {
    // 「有効期限切れ」メッセージ
    _status_message = glossary.glx(HistoryGL.Expired);
    _is_red = true;
  } else if (status == PlanStatus.MANUAL_UPDATE) {
    // 「自動更新オフ」メッセージ
    _status_message = glossary.glx(HistoryGL.ManualUpdate);
    _is_red = true;
  } else {
    // 「保留中」メッセージ
    _status_message = glossary.glx(HistoryGL.Hold);
    _is_red = true;
  }
  return (
    <div className="info" data-test={`${dataTest}`}>
      <Message
        type="message"
        subType="date"
        data-test={`${dataTest}-message-1`}
      >
        {operationDatetime}
      </Message>
      <Message
        type="message"
        subType={_is_red ? 'status red' : 'status'}
        data-test={`${dataTest}-message-2`}
      >
        {_status_message}
      </Message>
      <LinkText
        type="detailLink"
        data-test={`${dataTest}-message-3`}
        onClick={onClickDetail}
      >
        {planName}
      </LinkText>
      <Button
        type="nextButton"
        data-test={`${dataTest}-nextButton`}
        onClick={onClickPurchase}
        style={{ display: !_is_show ? 'none' : 'inline-block' }}
      >
        {glossary.glx(HistoryGL.Purchase)}
      </Button>
    </div>
  );
};

/**
 * 購入履歴のPresentation Component
 */
export const PurchaseHistory: React.FC<PurchaseHistoryProps> = ({
  'data-test': dataTest,
  ...props
}) => {
  return (
    <div className="history" data-test={dataTest}>
      <PurchaseHistoryInfo {...props} data-test={`${dataTest}-info`} />
    </div>
  );
};
